import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AppLayout from 'pages/AppLayout';
import Apps from 'pages/Apps/Apps';
import Auth from 'pages/Auth/Auth';
import Login from 'pages/Auth/Login';
import Register from 'pages/Auth/Register';
import Welcome from 'pages/Auth/Welcome';
import ClientPage from 'pages/ClientPage/ClientPage';
import CreatePaymentPage from 'pages/CreatePaymentPage/CreatePaymentPage';
import EditProduct from 'pages/EditProduct/EditProduct';
import Kasanie from 'pages/Kasanie';
import NotFound from 'pages/NotFound/NotFound';
import Payment from 'pages/Payment/Payment';
import PaymentDone from 'pages/PaymentDone/PaymentDone';
import PaymentPages from 'pages/Products/Products';
import Settings from 'pages/Settings/Settings';
import YooAuth from 'pages/YooAuth';

import Loader from 'components/Loader/Loader';

import { AuthProvider, RouteGuard } from './utils/auth';

import styles from './scss/styles.scss';

import './i18n';

const Companies = lazy(() => import('pages/Companies/Companies'));
const Clients = lazy(() => import('pages/Clients/Clients'));
const Join = lazy(() => import('pages/Auth/Join'));
const Unsubscribe = lazy(() => import('pages/Unsubscribe/Unsubscribe'));
const UnsubscribeByEmail = lazy(() => import('pages/UnsubscribeByEmail'));
const ResetPassword = lazy(() => import('pages/Auth/ResetPassword'));

document.getElementById('app').classList.add(styles.app);
const root = ReactDOM.createRoot(document.getElementById('app'));

const queryClient = new QueryClient();

root.render(
    <QueryClientProvider client={queryClient}>
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Auth />}>
                        <Route index element={<Welcome />} />
                        <Route path="login" element={<Login />} />
                        <Route path="register" element={<Register />} />
                        <Route
                            path="join"
                            element={
                                <Suspense fallback={<Loader dark={true} />}>
                                    <Join />
                                </Suspense>
                            }
                        />
                        <Route
                            path="reset"
                            element={
                                <Suspense fallback={<Loader dark={true} />}>
                                    <ResetPassword />
                                </Suspense>
                            }
                        />
                    </Route>
                    <Route path="/nspk/:id" element={<Kasanie />} />
                    <Route
                        path="companies"
                        element={
                            <RouteGuard>
                                <Suspense fallback={<Loader dark={true} />}>
                                    <Companies />
                                </Suspense>
                            </RouteGuard>
                        }
                    />
                    <Route
                        path="/"
                        element={
                            <RouteGuard>
                                <AppLayout />
                            </RouteGuard>
                        }
                    >
                        <Route index path="pages" element={<PaymentPages />} />
                        <Route path="pages/create" element={<CreatePaymentPage />} />
                        <Route path="pages/:pageId" element={<EditProduct />} />
                        <Route
                            path="clients"
                            element={
                                <Suspense fallback={<Loader dark={true} />}>
                                    <Clients />
                                </Suspense>
                            }
                        />
                        <Route path="clients/:clientId" element={<ClientPage />} />
                        <Route path="apps" element={<Apps />} />
                        <Route path="settings" element={<Settings />} />
                    </Route>
                    <Route path="/yookassa" element={<YooAuth />} />
                    <Route path="/pay/:pageId" element={<Payment />} />
                    <Route path="/done" element={<PaymentDone />} />
                    <Route
                        path="/unsubscribe"
                        element={
                            <Suspense fallback={<Loader dark={true} />}>
                                <Unsubscribe />
                            </Suspense>
                        }
                    />
                    <Route
                        path="/me"
                        element={
                            <Suspense fallback={<Loader dark={true} />}>
                                <UnsubscribeByEmail />
                            </Suspense>
                        }
                    />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    </QueryClientProvider>
);
